export default __webpack_public_path__ + "static/media/data-science.22f3577a.png";